import React from 'react';
import { is } from 'ramda';

export const Line = ({ index, children, LineComponent = 'span'}) => (
    <LineComponent className={'line line-' + (index + 1)} data-attr={index + 1}>
        {children}
    </LineComponent>
);

export const TextLine = (props) => {
    let line = '';

    if (is(String, props.value)) {
        line = props.value.split('\n').map((value, index) => (
            <Line index={index} key={index}>
                {value}<br/>
            </Line>
        ));
    } else {
        line = props.value || '';
    }

    return (
        <span className={props.className}>{line}</span>
    );
};

export const Counter = ({ value, className }) => {
    return (
        <span className={className}>
            {value + 1}
        </span>
    );
};

export const IndexCounter = ({ rowIndex, props }) => {
    return (
        <Counter {...props} value={rowIndex} />
    );
};
